import {
	PARENT_PRODUCTS,
	useConfluencePagePreviewPanel,
} from '@atlassian/confluence-page-preview-panel';

type OpenPreviewPanelParams = {
	url: string;
	title?: string;
};

// Helper function to check if we're in an iframe
const isInIframe = (): boolean => {
	try {
		return window !== window.top;
	} catch {
		// If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
		return true;
	}
};

// Helper function to check if previewPanels query parameter is present
const hasPreviewPanelsParam = (): boolean => {
	try {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.has('previewPanels');
	} catch {
		return false;
	}
};

// This is the function to add to, but the contents are currently just an example
export const useOpenPreviewPanel = () => {
	const { openConfluencePagePreviewPanel } = useConfluencePagePreviewPanel(
		PARENT_PRODUCTS.CONFLUENCE,
	);

	const openPreviewPanel = (params: OpenPreviewPanelParams) => {
		if (isInIframe() && hasPreviewPanelsParam()) {
			// Post message to parent frame to open the panel
			window.parent.postMessage(
				{
					type: 'OPEN_PREVIEW_PANEL',
					payload: params,
				},
				'*',
			);
			return;
		}

		const { url } = params;

		openConfluencePagePreviewPanel(url);
	};

	return { openPreviewPanel };
};
